import { useMsal } from "@azure/msal-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface SignOutDialogProps {
  onClose: () => void;
}
export const SignOutDialog = (props: SignOutDialogProps) => {
  const { instance } = useMsal();
  const signout = () => {
    instance.logout();
  };
  const cancel = props.onClose;

  return (
    <Dialog
      open={true}
      onClose={cancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        ¿Deseas cerrar tu sesión?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Tendrás que volver a iniciar sesión para continuar.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} color="error" autoFocus>
          Cancelar
        </Button>
        <Button onClick={signout} color="info">
          Cerrar sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};
